import placeholderDark from "../assets/images/placeholderDark.png";
import placeholderLight from "../assets/images/placeholderLight.png";
import Postgre from "../assets/images/Postgre.png";
import Prisma from "../assets/images/prisma.png";
import Nextjs from "../assets/images/Next.js.png";
import Render from "../assets/images/Render.png";
import RenderWhite from "../assets/images/RenderWhite.png";
import JWT from "../assets/images/logos_jwt-icon.png";
import Cloudinary from "../assets/images/Cloudinary.png";

export const Images = {
  placeholderDark,
  placeholderLight,
  Postgre,
  Prisma,
  Nextjs,
  Render,
  RenderWhite,
  JWT,
  Cloudinary
};